import { render, staticRenderFns } from "./loginPassword.vue?vue&type=template&id=1139bf10&scoped=true"
import script from "./loginPassword.vue?vue&type=script&lang=js"
export * from "./loginPassword.vue?vue&type=script&lang=js"
import style0 from "./loginPassword.vue?vue&type=style&index=0&id=1139bf10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139bf10",
  null
  
)

export default component.exports